<template>
    <div class="box mv_thankyou">
        <div>
        <h1 style="margin-top:0">Grazie!</h1>
        <h3>Il tuo numero d'ordine è {{reservationNumber}}</h3>
        <p>Riceverai la conferma della tua prenotazione direttamente nella tua mail.</p>
        <a @click="$root.$emit('hidePopup')">Chiudi</a>
        </div>
    </div>    
</template>

<script>
export default {
    props: ['reservationNumber']
}
</script>

<style lang="scss" scoped>

.mv_thankyou {
    box-sizing:border-box;padding: 2em;
    
    min-height: 300px;
    min-width: 500px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (max-width: 768px) {
        min-height: 90dvh;
        min-width: 0;
    }
}

</style>